/* eslint-disable max-lines-per-function */
import { cn } from "tailwind-variants";
import "./Tile.scss";

export default function Tile({ value, isSelected = false, onTileSelected, ...restProps }) {
  function handleClick(clickValue) {
    onTileSelected(clickValue);
  }

  return (
    <div {...restProps} className={cn("gang-sheet-builder-pdp-tile", restProps.className)}>
      <div
        className={cn("gang-sheet-builder-pdp-tile__button", {
          "gang-sheet-builder-pdp-tile__button--selected": isSelected
        })}
        onClick={() => {
          handleClick(value.value);
        }}
        data-testid="tile-div"
      >
        {value.label}
      </div>
    </div>
  );
}
